import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex w-full flex-1 items-center justify-center bg-background-100 px-4 py-20 md:px-6">
      <div className="w-full max-w-lg text-center">
        <span className="flex justify-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
            <i className="ri-movie-2-line text-3xl" />
          </span>
        </span>
        <h1 className="mt-6 font-heading text-4xl font-black text-foreground-950 md:text-5xl">404</h1>
        <p className="mt-3 font-heading text-lg font-bold text-foreground-800">这个页面走丢了</p>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在或已下架。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category/电影"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}